import { memo, useCallback, useEffect, useState } from "react";
import { TextField } from "ui/components/TextField/TextField";
import { VehicleDamageSearchFilterProps } from "./types";
import { FleetVehicleDamageSearchFormValues, DamageStatus } from "services/api/fleet/vehicles/damages/types";
import { initialFleetVehicleDamageSearchForm } from "services/api/fleet/vehicles/damages/consts";
import { getDamageStatusesAPI } from "services/api/fleet/vehicles/damages/api";
import { useTranslate } from "helpers";
import { Dropdown } from "ui/components/Dropdown/Dropdown";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";

const VehicleDamageSearchFilters: React.FC<
  VehicleDamageSearchFilterProps
> = (props) => {
  const { onSearchChange } = props;
  const { t } = useTranslate();

  const [formValues, setFormValues] =
    useState<FleetVehicleDamageSearchFormValues>(
      initialFleetVehicleDamageSearchForm
    );

  const [statuses, setStatuses] = useState<DamageStatus[]>([]);

  useEffect(() => {
    fetchStatuses();
  }, []);

  const fetchStatuses = async () => {
    try {
      const result = await getDamageStatusesAPI();
      setStatuses(result);
    } catch {
      // ignore
    }
  };

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const updatedFormValues = { ...formValues, search: e.target.value };
    setFormValues(updatedFormValues);
    onSearchChange(updatedFormValues);
  };

  const handleStatusChange = useCallback(
    (name: string, value: string | null) => {
      const updatedFormValues = {
        ...formValues,
        vehicleDamageStatusId: value,
      };
      setFormValues(updatedFormValues);
      onSearchChange(updatedFormValues);
    },
    [formValues, onSearchChange]
  );

  const handleResetFormClick = useCallback(() => {
    setFormValues(initialFleetVehicleDamageSearchForm);
    onSearchChange(initialFleetVehicleDamageSearchForm);
  }, [onSearchChange]);

  const statusItems: DropdownOption[] = statuses.map((s) => ({
    value: s.id,
    text: s.name,
  }));

  return (
    <>
      <div className="flex justify-between items-center ">
        <div className="flex flex-wrap gap-3">
          <div>
            <TextField
              type="text"
              name="search"
              value={formValues.search}
              onChange={handleSearchChange}
              placeholder={t("admin.search.placeholder")}
              startIcon="/media/icons/search.svg"
              cssClassName="bg-white"
            />
          </div>
          <div className="min-w-[200px]">
            <Dropdown
              name="vehicleDamageStatusId"
              placeholder={t("admin.fleet.damage.search.status.placeholder")}
              options={statusItems}
              onChange={handleStatusChange}
              value={formValues.vehicleDamageStatusId}
              width="full"
            />
          </div>
          <div className="flex items-center">
            <span
              onClick={handleResetFormClick}
              className="text-xs font-bold cursor-pointer text-gray-700"
            >
              {t("admin.reset")}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(VehicleDamageSearchFilters);
